import React, { useEffect, useState } from 'react'
import { CheckboxColor, CheckboxUnit, Checkboxs, DBFilterCheckboxArea, DBFilterDateArea, DBFilterWrapper, DateArea, GotoStatus } from '../DB/styles';
import { ConfigProvider, DatePicker, Input, Select } from 'antd';
import dayjs from 'dayjs';
import 'dayjs/locale/ko';
import locale from "antd/lib/locale/ko_KR";
import { RangePickerProps } from 'rc-picker/es/RangePicker.d';
import { Icon } from '../Main/styles';
import { IoSearch } from 'react-icons/io5';
import { FaArrowRotateRight } from 'react-icons/fa6';
import { useBranchList } from 'CRM/hooks/GetBranchList';
import { useFilterList } from 'CRM/hooks/GetFilterList';
import {useIsMobile} from "../../components/IsMobile";

const { RangePicker } = DatePicker;

export const EmployeeFilter = ({
  branch,
  setBranch,
  team,
  setTeam,
  createdAt,
  setCreatedAt,
  updatedAt,
  setUpdatedAt,
  word,
  setWord
}) => {
  const IsMobile = useIsMobile();
  useEffect(() => {
    setInputSearch(word)
    setInputBranch(branch)
    setInputTeam(team)
    setInputCreated([createdAt?.[0], createdAt?.[1]])
    setInputUpdated([updatedAt?.[0], updatedAt?.[1]])
  }, [branch, team, word, createdAt, updatedAt])
  const { branchList } = useBranchList();
  const { filterList: teamList } = useFilterList('team');
  const [inputCreated, setInputCreated] = useState<RangePickerProps<dayjs.Dayjs>['value'] | any>([null, null]);
  const [inputUpdated, setInputUpdated] = useState<RangePickerProps<dayjs.Dayjs>['value'] | any>([null, null]);
  const [inputTeam, setInputTeam] = useState(team);
  const [inputBranch, setInputBranch] = useState(branch);
  const [inputSearch, setInputSearch] = useState(word);

  const clickSearch = () => {
    const createdStart = inputCreated?.[0] ? dayjs(inputCreated?.[0]) : null;
    const createdEnd = inputCreated?.[1] ? dayjs(inputCreated?.[1]) : null;
  
    const updatedStart = inputUpdated?.[0] ? dayjs(inputUpdated?.[0]) : null;
    const updatedEnd = inputUpdated?.[1] ? dayjs(inputUpdated?.[1]) : null;
  
    setCreatedAt([createdStart, createdEnd]);
    setUpdatedAt([updatedStart, updatedEnd]);
    setBranch(inputBranch);
    setTeam(inputTeam);
    setWord(inputSearch);
  }
  
  const clickReset = () => {
    setCreatedAt([null, null])
    setUpdatedAt([null, null])
    setBranch('')
    setTeam('')
    setWord('')
  }

  return (
    <>
      {IsMobile ?
        <DBFilterWrapper style={{marginBottom: 20}}>
          <DBFilterDateArea>
            <DateArea>
              <label htmlFor='createdAt'>등록일</label>
              <ConfigProvider locale={locale}>
                <RangePicker
                  id='createdAt'
                  value={inputCreated}
                  onChange={(values) => setInputCreated(values)}
                />
              </ConfigProvider>
            </DateArea>
          </DBFilterDateArea>

          <DBFilterDateArea>
            <DateArea>
              <label htmlFor='createdAt'>수정일</label>
              <ConfigProvider locale={locale}>
                <RangePicker
                  id='createdAt'
                  value={inputUpdated}
                  onChange={(values) => setInputUpdated(values)}
                />
              </ConfigProvider>
            </DateArea>
          </DBFilterDateArea>

          <DBFilterDateArea>
              <DateArea>
                <label htmlFor='name'>팀별</label>
                <Select value={inputTeam} onChange={(e) => setInputTeam(e)}>
                  <option style={{ fontFamily: 'Pretendard' }} value={''}>없음</option>
                  {teamList?.map(it => (
                    <option style={{fontFamily: 'Pretendard'}} value={it.id}>{it.name}</option>
                  ))}
                </Select>
              </DateArea>
            </DBFilterDateArea>

          <DBFilterDateArea>
            <DateArea>
              <label htmlFor='name' style={{width: 180}}>이름 또는 연락처</label>
              <Input type='text' id='name' value={inputSearch} onChange={(e) => setInputSearch(e.target.value)} placeholder='이름 또는 연락처 검색' />
            </DateArea>
          </DBFilterDateArea>

          <DBFilterDateArea>
            <GotoStatus onClick={clickSearch} style={{backgroundColor: '#26DAD1'}}>
              <Icon><IoSearch /></Icon>
              검색
            </GotoStatus>
            <GotoStatus onClick={clickReset} style={{backgroundColor: '#5c636a'}}>
              <Icon><FaArrowRotateRight /></Icon>
              초기화
            </GotoStatus>
          </DBFilterDateArea>

        </DBFilterWrapper>
      :
        <DBFilterWrapper>
          <DBFilterDateArea>
            <DateArea>
              <label htmlFor='createdAt'>등록일</label>
              <ConfigProvider locale={locale}>
                <RangePicker
                  id='createdAt'
                  value={inputCreated}
                  onChange={(values) => setInputCreated(values)}
                />
              </ConfigProvider>
            </DateArea>
            <DateArea>
              <label htmlFor='createdAt'>수정일</label>
              <ConfigProvider locale={locale}>
                <RangePicker
                  id='createdAt'
                  value={inputUpdated}
                  onChange={(values) => setInputUpdated(values)}
                />
              </ConfigProvider>
            </DateArea>
          </DBFilterDateArea>
          <DBFilterDateArea>
            <>
              <DateArea>
                <label htmlFor='name'>팀별</label>
                <Select value={inputTeam} onChange={(e) => setInputTeam(e)}>
                  <option style={{ fontFamily: 'Pretendard' }} value={''}>없음</option>
                  {teamList?.map(it => (
                    <option style={{fontFamily: 'Pretendard'}} value={it.id}>{it.name}</option>
                  ))}
                </Select>
              </DateArea>
              <DateArea>
                <label htmlFor='name' style={{width: 180}}>이름 또는 연락처</label>
                <Input type='text' id='name' value={inputSearch} onChange={(e) => setInputSearch(e.target.value)} placeholder='이름 또는 연락처 검색' />
              </DateArea>
            </>
            <GotoStatus onClick={clickSearch} style={{backgroundColor: '#26DAD1'}}>
              <Icon><IoSearch /></Icon>
              검색
            </GotoStatus>
            <GotoStatus onClick={clickReset} style={{backgroundColor: '#5c636a'}}>
              <Icon><FaArrowRotateRight /></Icon>
              초기화
            </GotoStatus>
          </DBFilterDateArea>
        </DBFilterWrapper>
      }
    </>
  )
}

export default React.memo(EmployeeFilter);